import type { NsDict } from '../ru';

export const admin: NsDict<'admin'> = {
  title: 'Administration',
  signedIn: 'Sie sind angemeldet als Administrator',
  noPlay: 'Der Administrator nimmt nicht an Spielen teil.',
  'tab.overview': 'Übersicht',
  'tab.users': 'Benutzer',
  'tab.games': 'Spiele',

  'data.title': 'Daten',
  'data.mode': 'Modus',
  'data.modeReplay': 'Historie',
  'data.modeLive': 'live',
  'data.modeReplayHint': 'historische Wiedergabe; Ergebnisse fließen nicht in die Rangliste des Hauptmodus ein',
  'data.source': 'Quelle',
  'data.sourceSynthetic': 'synthetisch',
  'users.total': 'Gesamt',
  'users.online': 'Online',
  'users.new24h': 'Neu in 24 Std.',
  'users.new7d': 'Neu diese Woche',
  'users.active7d': 'Diese Woche gespielt',
  'users.banned': 'Gesperrt',
  'users.withPassword': 'Mit Passwort',
  'users.withSso': 'Über Dienste',
  'games.total': 'Gesamt',
  'games.last24h': 'Letzte 24 Std.',
  'games.completed': 'Abgeschlossen',
  'games.cancelled': 'Abgebrochen',
  'games.avgPlayers': 'Spieler im Schnitt',
  'games.humanShare': 'Anteil Menschen',
  'games.humanShareHint': 'Menschen unter allen Teilnehmern (der Rest sind Bots)',
  'credits.title': 'Credits',
  'credits.bank': 'Hauskonto',
  'credits.bankHint': 'angesammelte Kommission',
  'credits.commissionTotal': 'Kommission gesamt',
  'credits.granted': 'An Spieler ausgegeben',
  'credits.grantedHint': 'Start- und wiederhergestellte Guthaben',
  'credits.inPlay': 'Derzeit in Pots',
  'credits.inPlayHint': 'in nicht abgeschlossene Spiele eingezahlt',
  'credits.potTotal': 'Pot-Umsatz',
  'rooms.title': 'Aktuell',
  'rooms.open': 'Offene Tische',
  'rooms.playing': 'Laufende Spiele',
  'rooms.seated': 'Menschen an Tischen',
  'rooms.spectators': 'Zuschauer',
  'daily.games': 'Spiele nach Tagen',
  'daily.gamesValue': '{n} Spiel|{n} Spiele',
  'daily.commission': 'Kommission nach Tagen',
  'byTable.title': 'Nach Tischen',
  'byTable.empty': 'Es gab noch keine Spiele.',
  'byTable.ante': 'Ante',
  'byTable.games': 'Spiele',
  'byTable.pot': 'Umsatz',
  'byTable.commission': 'Kommission',
  'top.title': 'Beste Spieler',
  'top.empty': 'Bisher hat niemand gespielt.',
  'top.games': '{n} Spiel|{n} Spiele',

  'list.banPrompt': 'Grund für die Sperrung von {name} (für den Spieler sichtbar):',
  'list.searchPlaceholder': 'Suche nach Name, Benutzername oder ID',
  'list.searchLabel': 'Benutzer suchen',
  'list.filterAll': 'Alle',
  'list.filterOnline': 'Online',
  'list.filterBanned': 'Gesperrte',
  'list.empty': 'Niemand gefunden.',
  'list.colPlayer': 'Spieler',
  'list.colLogin': 'Anmeldung',
  'list.colActivity': 'Aktivität',
  'list.colGames': 'Spiele',
  'list.colWinRate': 'Gewinnquote',
  'list.colNet': 'Nettoergebnis',
  'list.colBalance': 'Guthaben',
  'list.tagOnline': 'online',
  'list.tagBanned': 'gesperrt',
  'list.sessionOnly': 'nur Sitzung',
  'list.now': 'jetzt',
  'list.profile': 'Profil',
  'list.ban': 'Sperren',
  'list.unban': 'Entsperren',
};
